<template>
  <div>
    <div class="desc">
      <div class="intro">
        <div class="left">
          <img class="line" src="../assets/index/line.png" alt="" />
          <div class="title">品牌介绍</div>
          <div class="subTitle">{{ title }}</div>
        </div>
        <div class="right" v-html="desc">
          <!-- <div class="gc" >
            哈尔滨阁韵窗业有限公司是一家定位于高端私属定制的铝包木窗研发、生产企业。专业为客户提供全国领先的铝包木门窗系统解决方案。公司创立于2014
            年，生产基地位于哈尔滨市南岗区前兴隆工业园区。<br /><br />
          </div> -->
          <!-- <div class="gn">
            阁韵窗业自创立以来，一直秉持专注、创新、利他、责任的阁韵精神，践行推广绿色科技门窗，引领环保舒适生活的阁韵使命，以客户利益为核心，以服务至上为立企之本，在行业内率先提出和落实“服务”理念，也是行业内首家与华为云服务平台签订战略合作的门窗企业。
            <br />
            <br />
            旗下建筑外窗、阳光房、幕墙系列铝包木产品涵盖了全国各个系列，获得研发专利近百项，2019年阁韵被认证为国家高新技术企业。2020年阁韵被动式系列产品获得国家康居认证，同时阁韵窗业被核准成为被动式低能耗建筑产业技术创新战略联盟会员单位。2021年阁韵窗业有限公司经过国家权威机构的审核认证，获得“环境管理体系认证证书”、“职业健康安全管理体系认证证书”，成功获得环境管理体系和职业健康安全管理体系的“双认证”。
            <br />
            <br />
            阁韵品牌创立至今，甄选世界顶级原材，匠心打造每一扇好窗，在行业内树立了良好的品牌声誉和服务口碑。目前公司在全国各大城市拥有服务商100余家。终端用户突破
            50000家，分布在全国各地。为方便客户选择和购买，2020年阁韵天猫旗舰店正式上线，同时阁韵木窗首创的客户订单可查询系统也一并上线。
          </div> -->
        </div>
      </div>
      <div class="about1"><img :src="`${banner}`" alt="" /></div>
    </div>

    <div class="lnWrap">
      <div class="ln">
        <div class="left">
          <img class="line" src="../assets/index/line.png" alt="" />
          <div class="title">品牌理念</div>
          <div class="subTitle">{{ idea_desc }}</div>
        </div>
      </div>

      <div class="lnBt">
        <div
          class="item"
          @mouseover="handleMouse(index)"
          v-for="(item, index) in idealist"
          :key="index"
        >
          <div class="spt">{{ item.title_en }}</div>
          <div class="img">
            <img
              class="sming"
              :src="active == index ? item.hover_image : item.image"
              alt=""
            />
          </div>
          <div class="title">{{ item.title }}</div>
          <div class="line"></div>
          <div v-html="item.desc" class="ms">
            <!-- 推广绿色科技门窗 <br />
            引领环保舒适生活 -->
          </div>
        </div>
      </div>
    </div>

    <div class="lnWrap">
      <div class="ln">
        <div class="left">
          <img class="line" src="../assets/index/line.png" alt="" />
          <div class="title">合作伙伴</div>
          <div class="subTitle">{{ partner_desc }}</div>
        </div>
      </div>
      <div class="lnBt">
        <!-- pc -->
        <div class="conWrap" v-if="!this.$isMobile">
          <div style="border-right: 1px solid #d3d3d3" class="left">
            <div
              class="list list1"
              @mouseover="handlePcLeft(index)"
              v-for="(item, index) in pclistleft"
              :key="index"
            >
              <img
                class="a1"
                :src="pclactive == index ? item.hover_image : item.image"
                alt=""
              />
              <div class="name">{{ item.title }}</div>
            </div>
          </div>
          <div class="right">
            <div
              class="list list6"
              @mouseover="handlePcRight(index)"
              v-for="(item, index) in pclistright"
              :key="index"
            >
              <img
                class="a6"
                :src="pcractive == index ? item.hover_image : item.image"
                alt=""
              />
              <div class="name">{{ item.title }}</div>
            </div>
          </div>
        </div>
        <!-- 移动 -->
        <div class="conWrap" v-else>
          <div
            class="list"
            @click="handleMobile(index)"
            v-for="(item, index) in mobilelist"
            :key="index"
          >
            <img
              class="a1"
              :src="mobilective == index ? item.hover_image : item.image"
              alt=""
            />
            <div class="name">{{ item.title }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { aboutIntroduce } from "../api/request";

export default {
  name: "Describe",
  data() {
    return {
      banner: null,
      desc: "",
      title: "",
      idea_desc: "",
      partner_desc: "",
      idealist: [],
      active: 0,
      pclistleft: [],
      pclactive: 0,
      pclistright: [],
      pcractive: 0,
      mobilective: 0,
      mobilelist: [],
    };
  },
  mounted() {
    aboutIntroduce().then((res) => {
      if (res.data.code == 1) {
        // console.log(res.data.data);
        var obj = res.data.data;
        this.banner = obj.banner;
        this.desc = obj.desc;
        // console.log(this.desc);
        this.title = obj.title;
        this.idea_desc = obj.idea_desc;
        this.partner_desc = obj.partner_desc;
        this.idealist = obj.idea;

        // pc左

        this.pclistleft = res.data.data.partner.slice(0, 5);
        this.pclistright = res.data.data.partner.slice(5);

        // 移动
        this.mobilelist = res.data.data.partner;
      }
    });
  },
  methods: {
    handleMouse(index) {
      this.active = index;
    },
    handlePcLeft(index) {
      this.pclactive = index;
    },
    handlePcRight(index) {
      this.pcractive = index;
    },
    handleMobile(index) {
      this.mobilective = index;
    },
  },
};
</script>

<style scoped lang="less">
.desc {
  padding-top: 60px;
  width: 1280px;
  margin: 0 auto;
  .intro {
    width: 1280px;
    margin: 0 auto;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    .left {
      text-align: left;
    }
    .line {
      width: 90px;
      height: 8px;
    }
    .title {
      font-size: 42px;
      font-family: 微软雅黑, MicrosoftYaHei;
      font-weight: bold;
      color: #004c31;
      margin-top: 38px;
    }
    .subTitle {
      margin-top: 24px;
      font-size: 24px;
      font-family: 微软雅黑, MicrosoftYaHei;
      font-weight: 400;
      color: #004c31;
    }
    .right {
      text-align: justify;
      width: 960px;
      .gc {
        margin-top: 70px;
        font-size: 20px;
        font-family: 微软雅黑, MicrosoftYaHei;
        font-weight: 400;
        color: #004c31 !important;
        line-height: 36px;
      }
      .gn {
        font-size: 20px;
        font-family: 微软雅黑, MicrosoftYaHei;
        font-weight: 400;
        color: #6c7a77 !important;
        line-height: 36px;
      }
    }
  }
  .about1 {
    width: 1280px;
    height: 451px;
    margin: 50px auto 0;
    img {
      width: 100%;
      height: 100%;
    }
  }
}
.lnWrap {
  width: 100%;
  margin: 101px auto 0;
  .ln {
    width: 1280px;
    margin: 0 auto;
    .left {
      text-align: left;
    }
    .line {
      width: 90px;
      height: 8px;
    }
    .title {
      font-size: 42px;
      font-family: 微软雅黑, MicrosoftYaHei;
      font-weight: bold;
      color: #004c31;
      margin-top: 38px;
    }
    .subTitle {
      margin-top: 24px;
      font-size: 24px;
      font-family: 微软雅黑, MicrosoftYaHei;
      font-weight: 400;
      color: #004c31;
    }
  }
  .lnBt {
    margin-top: 42px;
    width: 100%;
    padding: 72px 0;
    background: #f2f2f2;
    height: 464px;
    display: flex;
    align-items: center;
    justify-content: center;
    .item {
      width: 345px;
      height: 464px;
      .spt {
        font-size: 16px;
        color: #6c7a77;
        margin: 33px 0 0 49px;
        text-align: left;
      }
      .img {
        margin: 19px 0 0 161px;
        width: 137px;
        height: 140px;
        img {
          width: 137px;
          height: 140px;
        }
      }
      .title {
        text-align: left;
        margin: 42px 0 0 49px;
        font-size: 42px;
        font-weight: bold;
        color: #004c31;
      }
      .line {
        width: 43px;
        height: 4px;
        background: #004c31;
        text-align: left;
        margin: 20px 0 0 49px;
        border-radius: 20px;
      }
      .ms {
        margin: 20px 0 0 49px;
        font-size: 20px;
        font-family: MicrosoftYaHei;
        font-weight: 400;
        color: #6c7a77;
        line-height: 36px;
        text-align: left;
      }
      // &:hover .sming {
      //   content: url("../assets/about/smb.png");
      // }
      // &:hover .yjing {
      //   content: url("../assets/about/yjb.png");
      // }
      // &:hover .jsing {
      //   content: url("../assets/about/jsb.png");
      // }
      // &:hover .jzing {
      //   content: url("../assets/about/jzgb.png");
      // }
      &:hover .title {
        color: #ffffff;
      }
      &:hover .ms {
        color: #ffffff;
      }
      &:hover .line {
        background: #f7cf5c;
      }
      &:hover {
        background: #004c31;
      }
      &:hover .spt {
        color: #ffffff;
      }
    }
    .conWrap {
      width: 1280px;
      display: flex;
      align-items: center;
      justify-content: space-between;

      .left {
        width: 640px;

        .list {
          display: flex;
          align-items: center;

          img {
            width: 200px;
            height: 72px;
          }

          .name {
            text-align: right;
            width: 400px;
            font-size: 18px;
            font-family: MicrosoftYaHei;
            font-weight: 400;
            color: #6c7a77;
            line-height: 24px;
          }
        }
      }

      .right {
        width: 640px;

        .list {
          display: flex;
          align-items: center;
          justify-content: flex-end;

          img {
            width: 200px;
            height: 72px;
          }

          .name {
            text-align: right;
            width: 400px;
            font-size: 18px;
            font-family: MicrosoftYaHei;
            font-weight: 400;
            color: #6c7a77;
            line-height: 24px;
          }
        }
      }
      .list:hover {
        cursor: pointer;
      }
      // .list1:hover .a1 {
      //   content: url("../assets/about/a1.png");
      // }

      // .list2:hover .a2 {
      //   content: url("../assets/about/a2.png");
      // }

      // .list3:hover .a3 {
      //   content: url("../assets/about/a3.png");
      // }

      // .list4:hover .a4 {
      //   content: url("../assets/about/a4.png");
      // }

      // .list5:hover .a5 {
      //   content: url("../assets/about/a5.png");
      // }

      // .list6:hover .a6 {
      //   content: url("../assets/about/a6.png");
      // }
      // .list7:hover .a7 {
      //   content: url("../assets/about/a7.png");
      // }
      // .list:hover .a8 {
      //   content: url("../assets/about/a8.png");
      // }
      // .list:hover .a9 {
      //   content: url("../assets/about/a9.png");
      // }
      // .list:hover .a10 {
      //   content: url("../assets/about/a10.png");
      // }
    }
  }
}
@media screen and (max-width: 450px) {
  .desc {
    padding-top: 60px;
    width: 100%;
    margin: 0 auto;
    .intro {
      width: 1280px;
      margin: 0 auto;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: space-between;
      .left {
        text-align: left;
      }
      .line {
        width: 90 * 2px;
        height: 8 * 2px;
      }
      .title {
        font-size: 42 * 2px;
        font-family: 微软雅黑, MicrosoftYaHei;
        font-weight: bold;
        color: #004c31;
        margin-top: 38 * 2px;
      }
      .subTitle {
        margin-top: 24 * 2px;
        font-size: 24 * 2px;
        font-family: 微软雅黑, MicrosoftYaHei;
        font-weight: 400;
        color: #004c31;
      }
      .right {
        text-align: justify;
        width: 100%;
        .gc {
          margin-top: 70 * 2px;
          font-size: 20 * 2px;
          font-family: 微软雅黑, MicrosoftYaHei;
          font-weight: 400;
          color: #004c31;
          line-height: unset;
        }
        .gn {
          font-size: 20 * 2px;
          font-family: 微软雅黑, MicrosoftYaHei;
          font-weight: 400;
          color: #6c7a77;
          line-height: unset;
        }
      }
    }
    .about1 {
      width: 100%;
      height: auto;
      margin: 50px auto 0;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
  .lnWrap {
    width: 100%;
    margin: 101px auto 0;
    .ln {
      width: 1280px;
      margin: 0 auto;
      .left {
        text-align: left;
      }
      .line {
        width: 90 * 2px;
        height: 8 * 2px;
      }
      .title {
        font-size: 42 * 2px;
        font-family: 微软雅黑, MicrosoftYaHei;
        font-weight: bold;
        color: #004c31;
        margin-top: 38 * 2px;
      }
      .subTitle {
        margin-top: 24 * 2px;
        font-size: 24 * 2px;
        font-family: 微软雅黑, MicrosoftYaHei;
        font-weight: 400;
        color: #004c31;
      }
    }
    .lnBt {
      margin-top: 42 * 2px;
      width: 100%;
      padding: 72px 0;
      background: #f2f2f2;
      height: auto;
      display: flex;
      align-items: center;
      justify-content: center;
      .item {
        width: 345 * 2px;
        height: 464 * 2px;
        .spt {
          font-size: 16px;
          color: #6c7a77;
          margin: 33px 0 0 49px;
          text-align: left;
        }
        .img {
          margin: 19px 0 0 161px;
          width: 137 * 2px;
          height: 140 * 2px;
          img {
            width: 137 * 2px;
            height: 140 * 2px;
          }
        }
        .title {
          text-align: left;
          margin: 42px 0 0 49px;
          font-size: 42 * 2px;
          font-weight: bold;
          color: #004c31;
        }
        .line {
          width: 43 * 2px;
          height: 4 * 2px;
          background: #004c31;
          text-align: left;
          margin: 20px 0 0 49px;
          border-radius: 20px;
        }
        .ms {
          margin: 20px 0 0 49px;
          font-size: 20 * 2px;
          font-family: MicrosoftYaHei;
          font-weight: 400;
          color: #6c7a77;
          line-height: unset;
          text-align: left;
        }
        // &:hover .sming {
        //   content: url("../assets/about/smb.png");
        // }
        // &:hover .yjing {
        //   content: url("../assets/about/yjb.png");
        // }
        // &:hover .jsing {
        //   content: url("../assets/about/jsb.png");
        // }
        // &:hover .jzing {
        //   content: url("../assets/about/jzgb.png");
        // }
        // &:hover .title {
        //   color: #ffffff;
        // }
        // &:hover .ms {
        //   color: #ffffff;
        // }
        // &:hover .line {
        //   background: #f7cf5c;
        // }
        // &:hover {
        //   background: #004c31;
        // }
        // &:hover .spt {
        //   color: #ffffff;
        // }
      }
      .conWrap {
        width: unset;
        display: flex;
        align-items: center;
        flex-direction: column;
        justify-content: space-between;
        .list {
          display: flex;
          align-items: center;

          img {
            width: 200 * 2px;
            height: 72 * 2px;
          }

          .name {
            width: 1200px;
            text-align: right;
            font-size: 18 * 2px;
            font-family: MicrosoftYaHei;
            font-weight: 400;
            color: #6c7a77;
            line-height: 24 * 2px;
          }
        }
        .list:hover {
          cursor: pointer;
        }
        // .list1:hover .a1 {
        //   content: url("../assets/about/a1.png");
        // }

        // .list2:hover .a2 {
        //   content: url("../assets/about/a2.png");
        // }

        // .list3:hover .a3 {
        //   content: url("../assets/about/a3.png");
        // }

        // .list4:hover .a4 {
        //   content: url("../assets/about/a4.png");
        // }

        // .list5:hover .a5 {
        //   content: url("../assets/about/a5.png");
        // }

        // .list6:hover .a6 {
        //   content: url("../assets/about/a6.png");
        // }
        // .list7:hover .a7 {
        //   content: url("../assets/about/a7.png");
        // }
        // .list:hover .a8 {
        //   content: url("../assets/about/a8.png");
        // }
        // .list:hover .a9 {
        //   content: url("../assets/about/a9.png");
        // }
        // .list:hover .a10 {
        //   content: url("../assets/about/a10.png");
        // }
      }
    }
  }
}
</style>
